!function (global) {
  'use strict';

  var previousOfferDetailsServices = global.OfferDetailsServices;

  function OfferDetailsServices() {
    function getResults(params, url) {
      return $.ajax({
        method: 'POST',
        url: url,
        data: params,
        dataType: 'json'
      });
    }

    return {
      getResults: getResults
    }
  }

  OfferDetailsServices.noConflict = function noConflict() {
    global.OfferDetailsServices = previousOfferDetailsServices;
    return OfferDetailsServices;
  };

  global.OfferDetailsServices = OfferDetailsServices;
}(this);
